var _path, _circle, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84 3H20a1 1 0 011 1v15a1 1 0 01-1 1H4a1 1 0 01-1-1V3.84A.84.84 0 013.84 3z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "none",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "currentColor",
    d: "M12 6v4"
  })));
}

export default SvgScale;


//////////////////
// WEBPACK FOOTER
// ./src/icons/scale.svg
// module id = 875
// module chunks = 101